import vtkImageDataToCornerstoneImage from './ImageDataToCornerstoneImage';

export default {
  vtkImageDataToCornerstoneImage,
};
